var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00053 0.25C4.94965 0.25 2.05208 2.10493 0.841579 5.01574C-0.285361 7.72562 0.327285 10.035 1.59274 12.0023C2.62554 13.6079 4.13245 15.0411 5.47688 16.3198C5.73237 16.5628 5.98199 16.8002 6.22137 17.0322L6.223 17.0338C6.70034 17.4935 7.33774 17.75 8.00053 17.75C8.66331 17.75 9.30076 17.4935 9.77809 17.0337C10.0042 16.8159 10.2392 16.5932 10.4795 16.3655L10.4802 16.3648L10.4806 16.3645C11.8394 15.0769 13.367 13.6292 14.4106 12.0032C15.6745 10.034 16.285 7.72228 15.1595 5.01574C13.949 2.10493 11.0514 0.25 8.00053 0.25ZM8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.75C2.5212 17.75 2.94927 18.1487 2.99581 18.6578C3.01311 18.6768 3.04258 18.7053 3.09048 18.7431C3.26885 18.8836 3.58893 19.054 4.07359 19.2155C5.03245 19.5352 6.42072 19.75 8 19.75C9.57928 19.75 10.9675 19.5352 11.9264 19.2155C12.4111 19.054 12.7311 18.8836 12.9095 18.7431C12.9574 18.7053 12.9869 18.6768 13.0042 18.6578C13.0507 18.1487 13.4788 17.75 14 17.75C14.5523 17.75 15 18.1977 15 18.75C15 19.4639 14.5651 19.9848 14.1475 20.3139C13.7186 20.6519 13.16 20.9125 12.5589 21.1129C11.3462 21.5171 9.73443 21.75 8 21.75C6.26557 21.75 4.65384 21.5171 3.44113 21.1129C2.84 20.9125 2.2814 20.6519 1.85254 20.3139C1.43495 19.9848 1 19.4639 1 18.75C1 18.1977 1.44772 17.75 2 17.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.e6b5b9c9f22e0a2544b3ac81a0167bca.svg";
export { ForwardRef as ReactComponent };